module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('div', {
    staticClass: "footer-logo-wrapper"
  }, [_c('span', {
    staticClass: "footer-left-logo-mengguo"
  }), _vm._v(" "), _c('span', {
    staticClass: "footer-left-logo"
  })]), _vm._v(" "), _c('div', {
    staticClass: "Footer",
    staticStyle: {
      "margin": "-10px 0 10px 0",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticClass: "foot_zhonggao"
  }, [_c('ul', [_c('p', [_c('em', [_vm._v("健康游戏忠告")]), _vm._v("     "), _c('span', [_vm._v("抵制不良游戏")]), _vm._v("     "), _c('span', [_vm._v("拒绝盗版游戏")]), _vm._v("     "), _c('span', [_vm._v("注意自我保护")]), _vm._v("     "), _c('span', [_vm._v("谨防受骗上当")]), _vm._v("     "), _c('span', [_vm._v("适度游戏益脑")]), _vm._v("     "), _c('span', [_vm._v("沉迷游戏伤身")]), _vm._v("    "), _c('span', [_vm._v("合理安排时间")]), _vm._v("     "), _c('span', {
    staticClass: "zg_lt"
  }, [_vm._v("享受健康生活")])])])]), _vm._v(" "), _c('div', {
    staticClass: "foot_content"
  }, [_c('ul', [_c('p', [_c('img', {
    staticStyle: {
      "margin-bottom": "-3px"
    },
    attrs: {
      "src": require("../../../static/img/nav/huizhang.png"),
      "height": "20",
      "width": "20"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402002156"
    }
  }, [_vm._v("沪公网安备31010402002156号")])]), _vm._v(" "), _c('p', [_vm._v("\n                    Copyright © 2012 - 2020  上海萌果信息科技有限公司 版权所有 "), _c('br'), _vm._v("\n                    ICP证：沪ICP备12043106号     "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v("沪ICP备12043106号-10")]), _vm._v("    沪网文[2017] 2900-166号"), _c('br'), _vm._v("\n\n\n                    《"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "jiazhang.html"
    }
  }, [_vm._v("家长监护工程")]), _vm._v("》《"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "confirm.html"
    }
  }, [_vm._v("隐私政策")]), _vm._v("》\n                    "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://net.china.com.cn/"
    }
  }, [_vm._v("违法和不良信息举报中心")]), _vm._v("      "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.cyberpolice.cn/wfjb/"
    }
  }, [_vm._v("网络违法犯罪举报网站")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "liangzhao"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/253AC0DA3EFF4776AD432958C98955CA"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://106.75.226.95/install_package/statics/images/mengguo/wenhuatb.png"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.sgs.gov.cn/lz/licenseLink.do?method=licenceView&entyId=20130521165953303"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://106.75.226.95/install_package/statics/images/mengguo/liangzhaoicon.gif",
      "border": "0"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.shjbzx.cn"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/nav/jubao.png"),
      "width": "94",
      "height": "47"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-23c248ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/Footer.vue
// module id = 369
// module chunks = 13